<template>
    <div class="animated fadeIn">
        <!-- Splash section -->
        <section class="hero is-medium has-border-bottom-gray">
            <div class="hero-body">
                <div class="container">
                    <div class="columns is-vcentered">
                        <div class="column has-padding-top-2x-mobile">
                            <div class="columns is-centered is-vcentered contact-us-header-mailbox is-mobile">
                                <div class="column is-narrow padding-top-2x-mobile">
                                    <figure class="image rules-splash" v-if="!isMobile()">
                                        <img alt="Rules, privacy and policies" src="./assets/rules-splash.svg">
                                    </figure>
                                    <figure class="image rules-splash mobile-screen" v-else>
                                        <img alt="Rules, privacy and policies" src="./assets/rules-splash.svg">
                                    </figure>
                                </div>
                            </div>
                            <div class="columns is-centered padding-top-2x">
                                <h1 class="title is-size-2 has-text-centered-mobile uptin-text-center">
                                    {{ $t('rules:rules.title') }}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section" id="TOC">
            <div class="small-container">
                <div class="content is-medium">
                    <div class="has-text-centered">
                        <h2 class="title is-3 is-spaced is-margin-top-small uptin-text-center is-size-6">
                            {{ $t('rules:rules.subtitle') }}
                        </h2>
                        <p class="is-spaced is-margin-top-small uptin-text-center uptin-text-7">
                            {{ $t('rules:rules.date') }}
                        </p>
                    </div>
                    <br/>
                </div>
            </div>
        </section>
        <section class="section" id="faq">
            <div class="small-container">
                <!-- Introduction -->
                <div class="content is-medium">
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.pre_introduction') }}
                    </p>
                </div>

                <!-- Introduction -->
                <div class="content is-medium">
                    <h3 id="viral" class="is-size-5">
                        {{ $t('rules:rules.introduction') }}
                    </h3>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.introduction_desc') }}
                    </p>
                </div>

                <!-- Section 1 -->
                <div class="content is-medium">
                    <h3 id="sec1" class="is-size-5">
                        {{ $t('rules:rules.section1.title') }}
                    </h3>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section1.s1') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section1.s6') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section1.s12') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section1.s2') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section1.s3') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section1.s7') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section1.s10') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section1.s11') }}
                    </p>
                </div>

                <!-- Section 2 -->
                <div class="content is-medium">
                    <h3 id="sec2" class="is-size-5">
                        {{ $t('rules:rules.section2.title') }}
                    </h3>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section2.p1') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section2.p2') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section2.p3') }}
                    </p>
                </div>

                <!-- Section 3 -->
                <div class="content is-medium">
                    <h3 id="sec3" class="is-size-5">
                        {{ $t('rules:rules.section3.title') }}
                    </h3>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section3.p1') }}
                    </p>
                </div>

                <!-- Section 4 -->
                <div class="content is-medium">
                    <h3 id="sec4" class="is-size-5">
                        {{ $t('rules:rules.section4.title') }}
                    </h3>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section4.p1') }}
                    </p>
                </div>

                <!-- Section 5 -->
                <div class="content is-medium">
                    <h3 id="sec5" class="is-size-5">
                        {{ $t('rules:rules.section5.title') }}
                    </h3>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section5.p1') }}
                    </p>
                </div>

                <!-- Section 6 -->
                <div class="content is-medium">
                    <h3 id="sec6" class="is-size-5">
                        {{ $t('rules:rules.section6.title') }}
                    </h3>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section6.p1') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section6.p2') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section6.p3') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section6.p4') }}
                    </p>
                </div>

                <!-- Section 7 -->
                <div class="content is-medium">
                    <h3 id="sec7" class="is-size-5">
                        {{ $t('rules:rules.section7.title') }}
                    </h3>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section7.p1') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section7.p2') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section7.p3') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section7.p4') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section7.p5') }}
                    </p>
                </div>

                <!-- Section 8 -->
                <div class="content is-medium">
                    <h3 id="sec8" class="is-size-5">
                        {{ $t('rules:rules.section8.title') }}
                    </h3>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section8.p0.text') }}
                    </p>

                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section8.p1.text') }}
                    </p>


                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section8.p0.i1') }}
                    </p>
                    <p class="rule-text uptin-text-7" style="text-indent: 5%;">
                        {{ $t('rules:rules.section8.p0.i2') }}
                    </p>
                    <p class="rule-text uptin-text-7" style="text-indent: 5%;">
                        {{ $t('rules:rules.section8.p0.i3') }}
                    </p>
                    <p class="rule-text uptin-text-7" style="text-indent: 5%;">
                        {{ $t('rules:rules.section8.p0.i4') }}
                    </p>
                    <p class="rule-text uptin-text-7" style="text-indent: 5%;">
                        {{ $t('rules:rules.section8.p0.i5') }}
                    </p>
                    <p class="rule-text uptin-text-7" style="text-indent: 5%;">
                        {{ $t('rules:rules.section8.p0.i6') }}
                    </p>

                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section8.p1.i1') }}
                    </p>
                    <p class="rule-text uptin-text-7" style="text-indent: 5%;">
                        {{ $t('rules:rules.section8.p1.i2') }}
                    </p>
                    <p class="rule-text uptin-text-7" style="text-indent: 5%;">
                        {{ $t('rules:rules.section8.p1.i3') }}
                    </p>
                    <p class="rule-text uptin-text-7" style="text-indent: 5%;">
                        {{ $t('rules:rules.section8.p1.i4') }}
                    </p>

                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section8.p2') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section8.p3') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section8.p4') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section8.p5') }}
                    </p>
                </div>

                 <!-- Section 9 -->
                <div class="content is-medium">
                    <h3 id="sec9" class="is-size-5">
                        {{ $t('rules:rules.section9.title') }}
                    </h3>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section9.p1.text') }}
                    </p>
                    <p class="rule-text uptin-text-7" style="text-indent: 5%;">
                        {{ $t('rules:rules.section9.p1.i1') }}
                    </p>
                    <p class="rule-text uptin-text-7" style="text-indent: 5%;">
                        {{ $t('rules:rules.section9.p1.i2') }}
                    </p>
                    <p class="rule-text uptin-text-7" style="text-indent: 5%;">
                        {{ $t('rules:rules.section9.p1.i3') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section9.p2.text') }}
                    </p>
                    <div style="margin-start: 5%">
                        <p class="rule-text uptin-text-7">
                            {{ $t('rules:rules.section9.p2.i1') }}
                        </p>
                        <p class="rule-text uptin-text-7">
                            {{ $t('rules:rules.section9.p2.i2') }}
                        </p>
                        <p class="rule-text uptin-text-7">
                            {{ $t('rules:rules.section9.p2.i3') }}
                        </p>
                        <p class="rule-text uptin-text-7">
                            {{ $t('rules:rules.section9.p2.i4') }}
                        </p>
                        <p class="rule-text uptin-text-7">
                            {{ $t('rules:rules.section9.p2.i5') }}
                        </p>
                        <p class="rule-text uptin-text-7">
                            {{ $t('rules:rules.section9.p2.i6') }}
                        </p>
                    </div>
                    <br>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section9.p3.text') }}
                    </p>
                    <p class="rule-text uptin-text-7" style="text-indent: 5%;">
                        {{ $t('rules:rules.section9.p3.i1') }}
                    </p>
                    <p class="rule-text uptin-text-7" style="text-indent: 5%;">
                        {{ $t('rules:rules.section9.p3.i2') }}
                    </p>
                    <p class="rule-text uptin-text-7" style="text-indent: 5%;">
                        {{ $t('rules:rules.section9.p3.i3') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section9.p4') }}
                    </p>
                </div>

                <!-- Section 10 -->
                <div class="content is-medium">
                    <h3 id="sec10" class="is-size-5">
                        {{ $t('rules:rules.section10.title') }}
                    </h3>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section10.p1') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section10.p2') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section10.p3') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section10.p4') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section10.p5') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section10.p6') }}
                    </p>
                     <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section10.p7') }}
                    </p>
                     <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section10.p8') }}
                    </p>
                     <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section10.p9') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section10.p10') }}
                    </p>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.section10.p11') }}
                    </p>
                </div>

                <!-- Amendments -->
                <div class="content is-medium">
                    <h3 id="amendment" class="is-size-5">
                        {{ $t('rules:rules.amendments.title') }}
                    </h3>
                    <p class="rule-text uptin-text-7">
                        {{ $t('rules:rules.amendments.text') }}
                    </p>
                </div>
            </div>
        </section>
    </div>
</template>

<style lang="scss">
    .rule-text {
        text-align: justify;
        text-justify: inter-word;
        font-size: 15px;
    }

    .rules-splash {
        max-width: 300px;
        min-width: 300px;
        height: auto;

        &.position-top {
            top: -1em;
        }

        &.mobile-screen {
            max-width: 400px;
            min-width: 200px;
        }
    }

</style>

<script>
    export default {
        name: 'uptin-rules',
        components: {
        },
        methods: {
            isMobile() {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            }
        }
    }
</script>
